import { takeEvery, put, select } from "redux-saga/effects";
import { UploadFileForAssetAction, AdUnitFileUploadingStatusChangesAction } from "../actions";
import { AppState } from "store/store";
import { assetFormSelector } from "../selector";
import { enumerateForms } from "./enumerateForms";
import { uploadImageToBucketRequest } from "@common";

function* uploadFileForAssetCore(action: typeof UploadFileForAssetAction.typeInterface) {
    const appState: AppState = yield select();

    const assetForms = assetFormSelector(appState);

    const form = enumerateForms(assetForms).find(
        i => i.form.id === action.meta.formId && i.meta.index === action.meta.index
    );

    try {
        yield put(AdUnitFileUploadingStatusChangesAction({ uploadingFileId: action.uploadingFileId }));
        const frontImgUrlResponse: typeof uploadImageToBucketRequest.types.okResult = yield* uploadImageToBucketRequest.saga(
            {},
            {
                fileName: action.file.name
            }
        );

        yield fetch(frontImgUrlResponse.putUrl, {
            headers: {
                "Content-Type": action.file.type
            },
            method: "PUT",
            mode: "cors",
            cache: "no-cache",
            body: action.file
        });

        if (action.currentValue) {
            const newValue = [...(action.currentValue || []), frontImgUrlResponse.getUrl].filter(
                v => !!v && !!v.trim()
            );

            yield put(form.form.actions.fieldEdit(action.fieldName, newValue, action.meta));
        } else {
            yield put(form.form.actions.fieldEdit(action.fieldName, frontImgUrlResponse.getUrl, action.meta));
        }
        yield put(AdUnitFileUploadingStatusChangesAction({ uploadingFileId: undefined }));
    } catch (e) {
        yield put(AdUnitFileUploadingStatusChangesAction({ uploadingFileId: undefined }));
        yield put(
            form.form.actions.setErrors(
                {
                    fields: {
                        [action.fieldName]: ["Error occurred on uploading an file."]
                    }
                },
                action.meta
            )
        );

        console.error(e);
    }
}

export function* uploadFileForAsset() {
    yield takeEvery(UploadFileForAssetAction.type, uploadFileForAssetCore);
}
